import type React from 'react'
import { useCallback, useMemo } from 'react'

import useToggle from './use-toggle'

export default function useBoolean(defaultValue = false): readonly [
  boolean,
  {
    readonly toggle: (value?: boolean | undefined) => void
    readonly on: () => void
    readonly off: () => void
    readonly refState: React.RefObject<boolean>
  }
] {
  const { state, toggle, refState } = useToggle(defaultValue)

  const on = useCallback(() => toggle(true), [toggle])

  const off = useCallback(() => toggle(false), [toggle])

  const setActive = useMemo(
    () => ({ toggle, on, off, refState }),
    [off, on, refState, toggle]
  )

  return [state, setActive] as const
}
